import { ViewModeConfig } from "@components/view-mode-selector/view-mode-selector-types";
import { ListViewIcon, MapLargeIcon, TilesViewIcon } from "@flat-ui";
import { DataViewMode, DataViewModeSubject } from "@store/ui/ui-slice-types";

/** Available view modes for each subject type */
export const SUBJECT_VIEW_MODES: Record<DataViewModeSubject, DataViewMode[]> = {
  projects: ["cards", "list", "map"],
  groups: ["cards", "list"],
};

/** Configuration for each view mode */
export const VIEW_MODES_CONFIG: Record<DataViewMode, ViewModeConfig> = {
  cards: {
    tooltipTitle: "Tiles view",
    iconComponent: TilesViewIcon,
  },
  list: {
    tooltipTitle: "List view",
    iconComponent: ListViewIcon,
  },
  map: {
    tooltipTitle: "Map view",
    iconComponent: MapLargeIcon,
  },
};
